/**
 * 格式化价格，浮点数据保留1或2位小数点，整型不保留
 * @param val
 */
export function formatPrice(val: number): string {
  const fixedPrice = val.toFixed(2);
  const [head, tail] = fixedPrice.split('.');
  // 无小数值
  if (Number(tail) === 0) {
    return head;
  }
  // 1位小数 parseInt(1.10)，转换为1.1
  if (tail?.endsWith('0')) {
    return val.toFixed(1);
  }
  // 2位小数
  return val.toFixed(2);
}
